import { Helmet } from 'react-helmet'
import Header from '../../../Components/Header'
import Lpntable from './Components/Lpn-table'

const Delivery = () => {
    return (
        <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
             <Helmet>
				<title>Delivery Note List</title>
			</Helmet>
            <Header />
            <Lpntable />
            {/* <Footer /> */}
        </div>
    )
}

export default Delivery